import useSWR from "swr";

import { SERVICE_1, callLambda } from "src/utils/lambda";

export default () => useSWR("getFirstPublicSeries", () => callLambda({
  method   : "get",
  service  : SERVICE_1,
  url      : "getFirstPublicSeries",
  unauthed : true
}));
